// extracted by mini-css-extract-plugin
export default {"checkInputContainer":"BillCheckInput_checkInputContainer__0ga8n"};